/**
 * A porta entre o piloto (módulo 21; 0100) e o servidor: o painel do §17.2,
 * a carga inicial do §17.1, o grupo e as duas gravações.
 */
import { comCorpo, pedir } from '@/lib/pedido';

import type {
  Candidato,
  CargaInicial,
  EntradaNoPiloto,
  GrupoDoPiloto,
  PainelDoPiloto,
  PeriodoDoPiloto,
  RespostaDaEntrada,
  RespostaDaSaida,
  SaidaDoPiloto,
  TipoDoGrupo,
} from './piloto';

export const apiDoPiloto = {
  painel: (dias: PeriodoDoPiloto) => pedir<PainelDoPiloto>(`/piloto/painel?dias=${String(dias)}`),
  carga: (grupo: 'piloto' | 'todas', pendencia: string | undefined, pagina: number) =>
    pedir<CargaInicial>(`/piloto/carga?grupo=${grupo}${pendencia ? `&pendencia=${encodeURIComponent(pendencia)}` : ''}&pagina=${String(pagina)}`),
  grupo: () => pedir<GrupoDoPiloto>('/piloto/grupo'),
  candidatos: (tipo: TipoDoGrupo, termo: string) =>
    pedir<{ candidatos: readonly Candidato[] }>(`/piloto/candidatos?tipo=${tipo}&termo=${encodeURIComponent(termo)}`),
  entrar: (e: EntradaNoPiloto) =>
    comCorpo<RespostaDaEntrada>(
      'POST',
      e.tipo === 'maquina' ? '/piloto/maquinas' : '/piloto/pessoas',
      e.tipo === 'maquina'
        ? { equipamentoId: e.id, entrada: e.entrada, ...(e.observacao.trim() ? { observacao: e.observacao.trim() } : {}) }
        : { usuarioId: e.id, entrada: e.entrada, ...(e.observacao.trim() ? { observacao: e.observacao.trim() } : {}) },
    ),
  sair: (s: SaidaDoPiloto) =>
    comCorpo<RespostaDaSaida>('POST', `/piloto/${s.tipo === 'maquina' ? 'maquinas' : 'pessoas'}/${encodeURIComponent(s.id)}/saida`, { saida: s.saida }),
};

